import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from './index.module.css'

export interface LoadingProps {
  loading: boolean
  redirectTo?: string
  redirectURL?: string
}

export const Loading: React.FC<LoadingProps> = ({ loading = false, redirectTo, redirectURL }) => {
  const { t } = useTranslation('common', { keyPrefix: 'auth' })
  return redirectTo ? (
    <>
      <div className={styles.redirectBg}>
        <div className="absolute box-content px-4 max-w-xs max-h-sm transform flex flex-col justify-center items-center gap-9">
          <img src={`/${redirectTo.toLowerCase()}-redirect.svg`} alt={`Redirecting to ${redirectTo}...`} />
          <a
            href={redirectURL}
            className="w-fit bg-white px-4 py-2 rounded-xl font-bold text-brand_primary whitespace-break-spaces	flex items-center"
          >
            {t('redirectingTo')} {redirectTo}
            {'  '}
            <span className="spinner-border" />
          </a>
        </div>
      </div>
    </>
  ) : (
    loading && (
      <div className="fixed top-0 left-0 w-full h-full z-overlay progress bg-[rgba(236,_240,_241,_0.5)]">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[50px] h-[50px] ">
          <div className="w-full h-full rounded-[50%] bg-brand_primary opacity-60 absolute top-0 left-0 animate-[sk-bounce_2s_infinite_ease-in-out]" />
          <div className="w-full h-full rounded-[50%] bg-brand_secondary opacity-60 absolute top-0 left-0 animate-[sk-bounce_1s_infinite_ease-in-out] content-[' ']" />
        </div>
      </div>
    )
  )
}

export default Loading
